import { formatDate } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { cpf } from 'cpf-cnpj-validator';
import { CpfCnpjValidator } from 'ngx-cpf-cnpj';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { MarcacaoDTO } from '../../dtos/marcacao-dto';
import { TipoMarcacaoEnum } from '../../enums/tipo-marcacao-enum';
import { Paciente } from '../../paciente/paciente';
import { PacienteService } from '../../paciente/paciente.service';
import { Util } from '../../util/util';
import { MarcacaoConsulta } from '../marcacao-consulta/marcacao-consulta';
import { MarcacaoConsultaService } from '../marcacao-consulta/marcacao-consulta.service';
import { MarcacaoProcedimentoService } from '../marcacao-procedimento/marcacao-procedimento.service';
import { MarcacaoComponent } from '../marcacao.component';

@Component({
  selector: 'app-cadastro-paciente',
  templateUrl: './cadastro-paciente.component.html',
  styleUrls: ['./cadastro-paciente.component.css'],
})
export class CadastroPacienteComponent
  extends MarcacaoComponent
  implements OnInit
{
  nomeAtendenteLogado: String = '';

  formularioDeCadastroDePacienteConsultaCpf: FormGroup;

  formularioDeCadastroDePaciente: FormGroup;

  dependentes: Paciente[] = [];

  agendamentos: MarcacaoDTO[] = [];

  pacienteSelecionado: boolean = false;

  cpfValido: boolean = false;

  numeroDaLinhaSelecionadaNaTabelaDeDependente: number = -1;

  private cpfSubscription: Subscription | null = null;

  onClickNaTabelaDeDependente: any;

  temAgendamentos: boolean = false;

  constructor(
    private pacienteService: PacienteService,
    private marcacaoProcedimentoService: MarcacaoProcedimentoService,
    private marcacaoConsultaService: MarcacaoConsultaService,
    router: Router,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) {
    super(router);

    this.temAgendamentos = false;

    this.marcacaoConsulta = new MarcacaoConsulta();

    this.marcacaoConsulta.tipoMarcacao = history.state.tipoMarcacao;

    if (
      !this.marcacaoConsulta.tipoMarcacao ||
      (this.marcacaoConsulta.tipoMarcacao !=
        TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA &&
        this.marcacaoConsulta.tipoMarcacao !=
          TipoMarcacaoEnum.TIPO_MARCACAO_EXAME)
    ) {
      activatedRoute.data.subscribe((params) => {
        this.marcacaoConsulta.tipoMarcacao = params['tipoMarcacao'];

        if (
          !this.marcacaoConsulta.tipoMarcacao ||
          (this.marcacaoConsulta.tipoMarcacao !=
            TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA &&
            this.marcacaoConsulta.tipoMarcacao !=
              TipoMarcacaoEnum.TIPO_MARCACAO_EXAME)
        ) {
          this.router.navigate(['/']);
        }
      });
    }

    this.formularioDeCadastroDePacienteConsultaCpf = this.formBuilder.group({
      cpfPaciente: ['', CpfCnpjValidator.validate],
    });

    this.formularioDeCadastroDePaciente = this.formBuilder.group({});

    this.criarFormularioDeCadastroDePaciente(new Paciente());

    this.onClickNaTabelaDeDependente = function (index: number) {
      this.numeroDaLinhaSelecionadaNaTabelaDeDependente = index;
    };
  }

  ngOnInit(): void {
    this.configurarTitulo(
      this.marcacaoConsulta.tipoMarcacao == TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA
        ? '(Etapa 1 de 4)'
        : '(Etapa 1 de 5)',
      this.marcacaoConsulta.tipoMarcacao
    );

    if (history.state.pacienteTitular) {
      this.configurarPacienteVindoDaRequest();
    }

    // Auto-search CPF when field reaches full length (11 digits)
    const cpfCtrl = this.formularioDeCadastroDePacienteConsultaCpf.get('cpfPaciente');
    if (cpfCtrl) {
      this.cpfSubscription = cpfCtrl.valueChanges
        .pipe(debounceTime(300), distinctUntilChanged())
        .subscribe((value) => {
          const digits = value ? value.toString().replace(/\D/g, '') : '';
          if (digits.length === 11 && cpfCtrl.valid) {
            // Only search if not already validated to avoid duplicate calls
            if (!this.cpfValido) {
              this.consultarPacientePorCpf();
            }
          } else if (digits.length < 11) {
            // reset flags when input shortened
            this.cpfValido = false;
            this.pacienteSelecionado = false;
          }
        });
    }
  }

  onSubmit() {
    this.proximaTela();
  }

  criarFormularioDeCadastroDePaciente(paciente: Paciente): void {
    this.formularioDeCadastroDePaciente = this.formBuilder.group({
      nome: ['', [Validators.required, Validators.minLength(6)]],
      dataNascimento: ['', [Validators.required, Util.dataInvalida]],
      foneResidencial: [
        '',
        [Validators.minLength(14), Validators.maxLength(16)],
      ],
      foneCelular: ['', [Validators.minLength(14), Validators.maxLength(16)]],
    });
  }

  consultarPacientePorCpf() {
    this.pacienteSelecionado = false;
    this.cpfValido = false;

    let controlCpfPaciente: AbstractControl | null =
      this.formularioDeCadastroDePacienteConsultaCpf.get('cpfPaciente');

    if (
      controlCpfPaciente?.value != null &&
      controlCpfPaciente.value.length > 0 &&
      controlCpfPaciente?.valid
    ) {
      this.cpfValido = true;

      this.pacienteService
        .procurarPacientePorCpf(controlCpfPaciente.value)
        .subscribe(
          (data) => {
            // console.log(data)

            if (data) {
              this.marcacaoConsulta.paciente = data;
              this.configurarPacienteSelecionado(
                this.marcacaoConsulta.paciente
              );
            } else {
              this.marcacaoConsulta.paciente = new Paciente();
            }

            this.listarAgendamentosDoPacienteDataAtualOuPosteriorComProjecao();

            this.configurarValoresDoFormularioDePaciente();
          },
          (error) => {
            this.limparFormularioDePaciente();
            this.configurarBotaoAgendamento();
            console.log(error);
          }
        );
    } else {
      this.limparFormularioDePaciente();
      this.configurarBotaoAgendamento();
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Cpf Inválido!',
        },
      });
    }
  }

  limparFormularioDePaciente(): void {
    this.formularioDeCadastroDePaciente.reset(new Paciente());

    this.marcacaoConsulta.paciente = new Paciente();

    this.dependentes = [];
  }

  configurarValoresDoFormularioDePaciente(): void {
    this.formularioDeCadastroDePaciente.controls.nome.setValue(
      this.marcacaoConsulta.paciente.nome
    );
    this.formularioDeCadastroDePaciente.controls.foneResidencial.setValue(
      this.marcacaoConsulta.paciente.foneResidencial
    );
    this.formularioDeCadastroDePaciente.controls.foneCelular.setValue(
      this.marcacaoConsulta.paciente.foneCelular
    );

    if (this.marcacaoConsulta.paciente) {
      if (
        this.marcacaoConsulta.paciente.cpf &&
        this.marcacaoConsulta.paciente.dataNascimento
      ) {
        this.formularioDeCadastroDePaciente.controls.dataNascimento.setValue(
          formatDate(
            this.marcacaoConsulta.paciente.dataNascimento,
            'yyyy-MM-dd',
            'en'
          )
        );
      } else {
        this.formularioDeCadastroDePaciente.controls.dataNascimento.setValue(
          null
        );
      }

      if (this.marcacaoConsulta.paciente.dependentes) {
        this.dependentes = this.marcacaoConsulta.paciente.dependentes;
      } else {
        this.dependentes = [];
      }
    } else {
    }
  }

  formatDate(value: Date): string {
    return formatDate(value, 'dd/MM/yyyy', 'en');
  }

  navegarParaTelaDeCadastroDeDependente(): void {
    this.atualizarAtributosDoFormNaEntidadePaciente();

    this.router.navigate(['/marcacaoConsulta/cadastrarDependente'], {
      state: {
        pacienteTitular: this.marcacaoConsulta.paciente,
        tipoMarcacao: this.marcacaoConsulta.tipoMarcacao,
        agendamentos: this.agendamentos,
      },
    });
  }

  configurarPacienteVindoDaRequest(): void {
    this.marcacaoConsulta.paciente = history.state.pacienteTitular;

    this.configurarPacienteSelecionado(this.marcacaoConsulta.paciente);
    this.cpfValido = true;

    this.formularioDeCadastroDePacienteConsultaCpf.controls?.cpfPaciente.setValue(
      cpf.format(this.marcacaoConsulta.paciente.cpf)
    );

    this.configurarValoresDoFormularioDePaciente();

    if (history.state.agendamentos) {
      this.agendamentos = history.state.agendamentos;
    }

    this.configurarBotaoAgendamento();
  }

  configurarPacienteSelecionado(paciente: Paciente): void {
    this.pacienteSelecionado =
      paciente != null && paciente.id != null && paciente.id != 0;
  }

  removerDependenteSelecionado(): void {
    if (
      this.numeroDaLinhaSelecionadaNaTabelaDeDependente != -1 &&
      this.dependentes
    ) {
      this.dependentes.splice(
        this.numeroDaLinhaSelecionadaNaTabelaDeDependente,
        1
      );
    }
  }

  atualizarAtributosDoFormNaEntidadePaciente(): void {
    this.marcacaoConsulta.paciente.cpf =
      this.formularioDeCadastroDePacienteConsultaCpf.value.cpfPaciente;
    this.marcacaoConsulta.paciente.nome =
      this.formularioDeCadastroDePaciente.value.nome;
    this.marcacaoConsulta.paciente.dataNascimento =
      this.formularioDeCadastroDePaciente.value.dataNascimento;
    this.marcacaoConsulta.paciente.foneResidencial =
      this.formularioDeCadastroDePaciente.value.foneResidencial;
    this.marcacaoConsulta.paciente.foneCelular =
      this.formularioDeCadastroDePaciente.value.foneCelular;
    this.marcacaoConsulta.paciente.dependentes = this.dependentes;
  }

  salvarPacienteEContinuarMarcacao(): void {
    this.atualizarAtributosDoFormNaEntidadePaciente();
    console.log('salvarPacienteEContinuarMarcacao', this.agendamentos);

    if (
      this.marcacaoConsulta.paciente.foneCelular ||
      this.marcacaoConsulta.paciente.foneResidencial
    ) {
      if (this.marcacaoConsulta.paciente.id) {
        this.pacienteService
          .atualizar(this.marcacaoConsulta.paciente)
          .subscribe(
            (data) => {
              this.marcacaoConsulta.paciente = data as Paciente;

              // console.log(this.marcacaoConsulta.paciente)

              this.router.navigate(['/marcacaoConsulta/selecionarPaciente'], {
                state: {
                  marcacaoConsulta: this.marcacaoConsulta,
                  agendamentos: this.agendamentos,
                },
              });
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        this.pacienteService.criar(this.marcacaoConsulta.paciente).subscribe(
          (data) => {
            this.marcacaoConsulta.paciente = data as Paciente;

            // console.log(this.marcacaoConsulta.paciente)

            this.router.navigate(['/marcacaoConsulta/selecionarPaciente'], {
              state: {
                marcacaoConsulta: this.marcacaoConsulta,
                agendamentos: history.state.agendamentos,
              },
            });
          },
          (error) => {
            console.log(error);
          }
        );
      }
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Preencha pelo menos um número de telefone!',
        },
      });
    }
  }

  telaAnterior(): void {
    this.router.navigate(['/paginaInicial']);
  }

  proximaTela(): void {
    this.salvarPacienteEContinuarMarcacao();
  }

  listarAgendamentosDoPacienteDataAtualOuPosteriorComProjecao(): void {
    if (
      this.marcacaoConsulta.tipoMarcacao &&
      this.marcacaoConsulta &&
      this.marcacaoConsulta.paciente &&
      this.marcacaoConsulta.paciente.id
    ) {
      if (
        this.marcacaoConsulta.tipoMarcacao ==
        TipoMarcacaoEnum.TIPO_MARCACAO_EXAME
      ) {
        this.marcacaoProcedimentoService
          .listarAgendamentosDoPacienteDataAtualOuPosteriorComProjecao(
            this.marcacaoConsulta.paciente.id
          )
          .subscribe(
            (data) => {
              // console.log(data)

              this.agendamentos = data;

              this.configurarBotaoAgendamento();
            },
            (error) => {
              this.agendamentos = [];
              console.log(error);
            }
          );
      } else if (
        this.marcacaoConsulta.tipoMarcacao ==
        TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA
      ) {
        this.marcacaoConsultaService
          .listarAgendamentosDoPacienteDataAtualOuPosteriorComProjecao(
            this.marcacaoConsulta.paciente.id
          )
          .subscribe(
            (data) => {
              // console.log(data)

              this.agendamentos = data;

              this.configurarBotaoAgendamento();
            },
            (error) => {
              this.agendamentos = [];
              console.log(error);
            }
          );
      } else {
        this.configurarBotaoAgendamento();
      }
    } else {
      this.configurarBotaoAgendamento();
    }
  }

  configurarBotaoAgendamento(): void {
    this.temAgendamentos =
      this.agendamentos != null && this.agendamentos.length > 0;

    if (!this.temAgendamentos) {
      this.agendamentos = [];
    }
  }

  navegarParaTelaDeAgendamentosDoPaciente(): void {
    this.atualizarAtributosDoFormNaEntidadePaciente();

    this.router.navigate(['/marcacaoConsulta/agendamentosPaciente'], {
      state: {
        pacienteTitular: this.marcacaoConsulta.paciente,
        tipoMarcacao: this.marcacaoConsulta.tipoMarcacao,
        agendamentos: this.agendamentos,
      },
    });
  }

  ngOnDestroy(): void {
    if (this.cpfSubscription) {
      this.cpfSubscription.unsubscribe();
      this.cpfSubscription = null;
    }
  }
}
